<template>
  <transition name="modal" v-if="active">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <h4>¡Importante!</h4>
          </div>
          <div class="modal-body icon">
            <img src="@/assets/images/warning.svg" alt="Warning icon" />
          </div>
          <div class="modal-body">
            <p>{{ message }}</p>
          </div>
          <div class="modal-footer">
            <button @click="$emit('cancel')" class="button cancel">
              {{ cancelText }}
            </button>
            <button @click="$emit('confirm')" class="button accept">
              {{ confirmText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ConfirmationModal',
  props: {
    active: {
      type: Boolean,
      required: true
    },
    cancelText: {
      type: String,
      default: 'Regresar'
    },
    confirmText: {
      type: String,
      default: 'Aceptar'
    },
    message: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
@import  '@/assets/styles/constants.scss';

.button {
  font-size: 1rem;
  border-radius: 20px;
  border: 0;
  padding: 0.6em 1.5em;
  margin: 31px 0;
  cursor: pointer;

  &.accept {
    color: $white;
    background-color: $light-blue;

    &:focus {
      outline-width: 0;
    }
  }

  &.cancel {
    background-color: $white;
    color: $light-blue;
    border: 1px solid $light-blue;

    &:focus {
      outline-width: 0;
    }
  }
}

.modal-mask {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
  z-index: 5;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  border-radius: 20px !important;
}

.modal-header {
  width: 100%;
  display: flex;
  justify-content: center;
}

.modal-body {
  width: 100%;
  display: flex;
  text-align: center;

  &.icon {
    display: block;
  }
}

.modal-footer {
  width: 100%;
  display: flex;
  justify-content: space-around;

}

.modal-default-button {
  float: right;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  transform: scale(1.1);
}
</style>
